import _defineProperty from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import * as echarts from 'echarts';
export default {
  name: 'Echarts',
  data: function data() {
    return {
      firstCharts: {
        obj: {} // Echarts对象
        ,
        firstChartsOptions: {} // Echarts配置
        ,
        firstChartsGraphics: {
          graphic: {
            // Echarts Graphic 组件配置
            elements: [] // 元素集合
          }
        },
        firstChartsData: {
          // Echarts数据
          xAxis: ['1000MHz', '2000MHz', '3000MHz', '4000MHz', '5000MHz', '6000MHz', '7000MHz', '8000MHz', '9000MHz', '10000MHz', '11000MHz', '12000MHz', '13000MHz', '14000MHz', '15000MHz', '16000MHz', '17000MHz', '18000MHz'],
          yAxis: [200, 200, 300, 900, 300, 400, 300, 400, 100, 100, 400, 300, 400, 300, 1000, 300, 200, 200],
          yAxisMax: 1000 // Y轴最大值（用户规定横线移动范围，应在初始化时计算）
          ,
          yAxisMaxOffset: 100 // Y轴最大值偏移量 (防止最大值在图表顶端，线移动不清晰)
        },
        searchStep: 10,
        firstChartsMaxValue: 1100 // 图表Y轴最大值（this.firstCharts.firstChartsData.yAxisMax + this.firstCharts.firstChartsData.yAxisMaxOffset）
        ,
        firstChartsSelectData: {
          // Echarts选择区域数据
          brushType: null // 选择区域类型【lineX: 水平选择，lineY: 垂直选择】
          ,
          start: null,
          end: null,
          xAxis: null
        }
      }
    };
  },
  mounted: function mounted() {
    // 初始化图表
    this.initChart();
    // 初始化Graphic
    this.initGraphic();
  },
  methods: {
    initChart: function initChart() {
      this.firstCharts.obj = echarts.init(document.getElementById('line-chart'));
      this.firstChartsOptions = {
        title: {
          show: true // 是否显示标题
          ,
          text: '电磁波监测' // 主标题
          ,
          subtext: '图表示例' // 副标题
          ,
          left: 'center' // 对齐方式
        },
        grid: {
          // 配置网格间距
          show: true // 是否显示直角坐标系
          ,
          backgroundColor: '#000' // 背景颜色
        },
        xAxis: {
          // X轴配置
          type: 'category',
          boundaryGap: false // 坐标轴留白策略【true: 两坐标轴中间，false：坐标轴上】
          ,
          data: this.firstCharts.firstChartsData.xAxis,
          axisTick: {
            show: false // 隐藏 X 轴刻度线
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' // 线类型
              ,
              color: '#eeeeee' // X 轴分隔线颜色
            }
          },
          axisLabel: {
            // interval: 0, // 强制显示所有刻度标签
            rotate: 30 // 旋转角度，可以调整标签的倾斜角度
          }
        },
        yAxis: {
          // Y轴配置
          type: 'value',
          axisTick: {
            show: false // 隐藏 Y 轴刻度线
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' // 线类型
              ,
              color: '#eeeeee' // Y 轴分隔线颜色
            }
          },
          max: this.firstCharts.firstChartsMaxValue
        },
        series: [
        // 图表数据
        {
          type: 'line' // 图表类型
          ,
          lineStyle: {
            // 折线样式
            color: '#c4c51e' // 折线颜色
          },
          data: this.firstCharts.firstChartsData.yAxis,
          markLine: {
            // 标记线
            silent: true,
            data: [],
            symbolSize: 0 // 标记线两端标记大小
            ,
            lineStyle: {
              // 标记线样式
              width: 2 // 标记线宽度
              //, type: 'dashed' // 标记线类型[solid: 直线, dashed: 段线, dotted: 点线]
            }
          },
          markPoint: {
            // 标记点
            data: [] // 标记点数据
          }
        }]
        // , dataZoom: [ // 缩放漫游组件
        //   {
        //     type: 'inside' // 水平缩放
        //     , xAxisIndex: 0 // 对应 X 轴
        //   }
        // ]
        ,
        brush: {
          // 区域选择组件
          transformable: false // 选中区域禁止平移
          ,
          xAxisIndex: 'all',
          throttleDelay: 250,
          throttleType: 'debounce'
          // , toolbox: ['lineX', 'lineY', 'clear'] // 包含按钮: X轴选择，Y轴选择，清空
          ,
          toolbox: ['lineX', 'clear'] // 包含按钮: X轴选择，清空（Y轴选择与客户沟通先去掉）
        },
        toolbox: {
          // 工具栏
          show: true // 显示工具栏
          ,
          feature: {
            // 工具配置
            brush: {} // 区域选择组件（单独配置，此处为规定按钮顺序）
            ,
            saveAsImage: {
              // 保存为图片工具
              type: 'png' // 图片保存格式
              ,
              name: '保存' // 按钮名称
            }
          }
        }
      };

      // 写入配置
      this.firstCharts.obj.setOption(this.firstChartsOptions || {}, true);

      // 绑定区域选择回调事件（不使用brushEnd事，因为监控不到选择区域清空）
      this.firstCharts.obj.on('brushSelected', this.brushSelected); //
    },
    initGraphic: function initGraphic() {
      var _this = this;
      // 判断是否存在标记线
      if (this.firstChartsOptions.series[0].markLine.data.length <= 0) {
        return;
      }

      // 遍历标记线
      var _loop = function _loop() {
          markLine = _this.firstChartsOptions.series[0].markLine.data[i]; // 判断标记线类型
          markLineType = Object.prototype.hasOwnProperty.call(markLine, 'xAxis');
          rectExist = false; // 判断该标记线是否已存在
          for (j = 0; j < _this.firstCharts.firstChartsGraphics.graphic.elements.length; j++) {
            graphicRect = _this.firstCharts.firstChartsGraphics.graphic.elements[j];
            if (graphicRect.id === markLine.id) {
              rectExist = true;

              // 存在标记线矩形框，变更位置
              _this.firstCharts.firstChartsGraphics.graphic.elements[j].shape.x = markLineType ? _this.firstCharts.obj.convertToPixel({
                xAxisIndex: 0
              }, markLine.xAxis) - 2.5 : _this.firstCharts.obj.convertToPixel({
                xAxisIndex: 0
              }, 0); // X轴位置
              _this.firstCharts.firstChartsGraphics.graphic.elements[j].shape.y = markLineType ? _this.firstCharts.obj.convertToPixel({
                yAxisIndex: 0
              }, 0) : _this.firstCharts.obj.convertToPixel({
                yAxisIndex: 0
              }, markLine.yAxis) - 2.5; // Y轴位置
            }
          }

          // 获取外部this
          var that = _this;

          // 矩形框数据
          if (!rectExist) {
            // 不存在新增矩形框
            rect = {
              id: markLine.id,
              type: 'rect' // 矩形
              ,
              bounding: 'all' // 元素定位
              ,
              shape: {
                // 形状信息
                // TODO: 矩形框宽高运算
                width: markLineType ? 5 : _this.firstCharts.obj.getWidth() - 335 // 宽
                ,
                height: markLineType ? -(_this.firstCharts.obj.getHeight() - 120) : 5 // 高
                ,
                x: markLineType ? _this.firstCharts.obj.convertToPixel({
                  xAxisIndex: 0
                }, markLine.xAxis) - 2.5 : _this.firstCharts.obj.convertToPixel({
                  xAxisIndex: 0
                }, 0) // X轴位置
                ,
                y: markLineType ? _this.firstCharts.obj.convertToPixel({
                  yAxisIndex: 0
                }, 0) : _this.firstCharts.obj.convertToPixel({
                  yAxisIndex: 0
                }, markLine.yAxis) - 2.5 // Y轴位置
              },
              style: {
                lineWidth: 1 // 宽度
                ,
                fill: 'green' // 拖拽标记线蒙层的填充色
                ,
                stroke: 'rgba(0,0,0,0.3)' // 颜色 (透明)
              },
              draggable: markLineType ? 'horizontal' : 'vertical' // 启用拖拽[false: 不允许拖拽, true: 允许拖拽, horizontal: 只允许水平拖拽, vertical: 只允许垂直拖拽]
              ,
              invisible: true // TODO: 隐藏标记线蒙层
              ,
              cursor: 'pointer' // 鼠标悬浮样式
              ,
              onclick: function () {
                var _onclick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dataIndex) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return that.selectMark(markLine.id);
                      case 2:
                        _context.next = 4;
                        return that.firstCharts.obj.setOption(that.firstChartsOptions || {}, true);
                      case 4:
                        _context.next = 6;
                        return that.initGraphic();
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                function onclick(_x) {
                  return _onclick.apply(this, arguments);
                }
                return onclick;
              }(),
              ondragend: function () {
                var _ondragend = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dataIndex) {
                  var xAxisIndex, yAxisValue;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return that.selectMark(markLine.id);
                      case 2:
                        if (!markLineType) {
                          _context2.next = 11;
                          break;
                        }
                        xAxisIndex = that.firstCharts.obj.convertFromPixel({
                          xAxisIndex: 0
                        }, dataIndex.offsetX);
                        xAxisIndex = xAxisIndex < 0 ? 0 : xAxisIndex >= that.firstCharts.firstChartsData.xAxis.length ? that.firstCharts.firstChartsData.xAxis.length - 1 : xAxisIndex;

                        // 变更标记线
                        _context2.next = 7;
                        return that.modifyMarkLine(markLine.id, 'xAxis', xAxisIndex);
                      case 7:
                        _context2.next = 9;
                        return that.modifyMarkPoint(markLine.id, xAxisIndex);
                      case 9:
                        _context2.next = 15;
                        break;
                      case 11:
                        yAxisValue = that.firstCharts.obj.convertFromPixel({
                          yAxisIndex: 0
                        }, dataIndex.offsetY);
                        yAxisValue = yAxisValue < 0 ? 0 : yAxisValue >= that.firstCharts.firstChartsData.yAxisMax + that.firstCharts.firstChartsData.yAxisMaxOffset ? that.firstCharts.firstChartsData.yAxisMax + that.firstCharts.firstChartsData.yAxisMaxOffset : yAxisValue;

                        // 变更标记线
                        _context2.next = 15;
                        return that.modifyMarkLine(markLine.id, 'yAxis', yAxisValue);
                      case 15:
                        _context2.next = 17;
                        return that.firstCharts.obj.setOption(that.firstChartsOptions || {}, true);
                      case 17:
                        _context2.next = 19;
                        return that.initGraphic();
                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                function ondragend(_x2) {
                  return _ondragend.apply(this, arguments);
                }
                return ondragend;
              }()
            }; // 存入数据
            _this.firstCharts.firstChartsGraphics.graphic.elements.push(rect);
          }
        },
        markLine,
        markLineType,
        rectExist,
        j,
        graphicRect,
        rect;
      for (var i = 0; i < this.firstChartsOptions.series[0].markLine.data.length; i++) {
        _loop();
      }

      // 初始化Graphic组件 (Graphic需要在第一次setOption后进行，即必须在坐标系grid初始化后才能调用 charts.convertToPixel)
      this.firstCharts.obj.setOption(this.firstCharts.firstChartsGraphics);
    },
    peak: function peak() {
      // 判断是否存在标记线
      if (this.firstChartsOptions.series[0].markLine.data.length > 0) {
        // 判断是否选中标记线
        for (var i = this.firstChartsOptions.series[0].markLine.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markLine.data[i].lineStyle.type === 'solid') {
            // 判断是否为选中标记线（根据标记线类型判断，选中的应为直线）
            // 计算峰值
            var maxData = this.getMaxData();

            // 判断标记线类型
            var markLineType = Object.prototype.hasOwnProperty.call(this.firstChartsOptions.series[0].markLine.data[i], 'xAxis');

            // 变更标记线位置
            this.modifyMarkLine(this.firstChartsOptions.series[0].markLine.data[i].id, markLineType ? 'xAxis' : 'yAxis', markLineType ? maxData.maxIndex : maxData.maxValue);
            // 变更标记点位置
            this.modifyMarkPoint(this.firstChartsOptions.series[0].markLine.data[i].id, maxData.maxIndex);

            // 重载图表 TODO: 存在问题，setOption会刷掉区域选择
            this.firstCharts.obj.setOption(this.firstChartsOptions || {}, true);
            // 重载Graphic组件
            this.initGraphic();
          }
        }
      }
    },
    subPeak: function subPeak() {
      // #00FF00
    },
    leftPeak: function leftPeak() {
      // #00FF00
    },
    rightPeak: function rightPeak() {
      // #00FF00
    },
    brushSelected: function brushSelected(event) {
      // 选择框变化事件
      if (event.batch[0].areas.length > 0) {
        // 区域选择类型
        this.firstCharts.firstChartsSelectData.brushType = event.batch[0].areas[0].brushType;
        // // 起终范围
        this.firstCharts.firstChartsSelectData.start = event.batch[0].areas[0].coordRange[0];
        // // 终止范围
        this.firstCharts.firstChartsSelectData.end = event.batch[0].areas[0].coordRange[1];
      } else {
        // 区域选择类型
        this.firstCharts.firstChartsSelectData.brushType = null;
        // // 起终范围
        this.firstCharts.firstChartsSelectData.start = null;
        // // 终止范围
        this.firstCharts.firstChartsSelectData.end = null;
      }
    },
    getMaxData: function getMaxData() {
      var maxItem = {
        maxIndex: null,
        maxValue: null
      };

      // 判断是否存在可供计算的数据
      if (this.firstCharts.firstChartsData !== null && this.firstCharts.firstChartsData.xAxis !== null && this.firstCharts.firstChartsData.yAxis !== null) {
        // 判断是否存在勾选区域
        if (this.firstCharts.firstChartsSelectData.brushType === null) {
          // 从全部数据中选择
          for (var i = 0; i < this.firstCharts.firstChartsData.yAxis.length; i++) {
            // 判断比较值是否大于原值
            if (this.firstCharts.firstChartsData.yAxis[i] > (this.firstCharts.firstChartsData.yAxis[maxItem.maxIndex] || 0)) {
              maxItem.maxIndex = i;
              maxItem.maxValue = this.firstCharts.firstChartsData.yAxis[i];
            }
          }
        } else if (this.firstCharts.firstChartsSelectData.brushType === 'lineX') {
          // 从X轴（纵向）数据中选择
          for (var j = this.firstCharts.firstChartsSelectData.start; j < this.firstCharts.firstChartsSelectData.end; j++) {
            // 判断比较值是否大于原值
            if (this.firstCharts.firstChartsData.yAxis[j] > this.firstCharts.firstChartsData.yAxis[maxItem.maxIndex || 0]) {
              maxItem.maxIndex = j;
              maxItem.maxValue = this.firstCharts.firstChartsData.yAxis[j];
            }
          }
        } else if (this.firstCharts.firstChartsSelectData.brushType === 'lineY') {
          // 从Y轴（横向）数据中选择
          for (var k = 0; k < this.firstCharts.firstChartsData.yAxis.length; k++) {
            if (this.firstCharts.firstChartsData.yAxis[k] >= this.firstCharts.firstChartsSelectData.start && this.firstCharts.firstChartsData.yAxis[k] <= this.firstCharts.firstChartsSelectData.end) {
              // 判断比较值是否大于原值
              if (this.firstCharts.firstChartsData.yAxis[k] > this.firstCharts.firstChartsData.yAxis[maxItem.maxIndex || 0]) {
                maxItem.maxIndex = k;
                maxItem.maxValue = this.firstCharts.firstChartsData.yAxis[k];
              }
            }
          }
        }
      }
      return maxItem;
    },
    addMark: function addMark(markType, direction, index, value, color) {
      this.addMarkLine(markType, direction, index, color);

      // yAxis 不增加标记点
      if (direction !== 'yAxis') {
        this.addMarkPoint(markType, index, value, color);
      }
    },
    clearMark: function clearMark(pointType) {
      this.clearMarkLine(pointType);
      this.clearMarkPoint(pointType);
    },
    existMarkLine: function existMarkLine(lineType) {
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markLine.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markLine.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markLine.data[i].id === lineType) {
            // 判断标记线类型
            return true;
          }
        }
      }
      return false;
    },
    addMarkLine: function addMarkLine(lineType, direction, value, color) {
      // 过滤无效和已存在数据
      if (value === null || this.existMarkLine(lineType)) {
        return;
      }

      // 创建标记线对象
      var markLine = _defineProperty(_defineProperty(_defineProperty({
        id: lineType // 标记线ID
        ,
        name: lineType // 标记线类型
      }, direction, value), "lineStyle", {
        // 标记线样式
        color: color // 标记线颜色
        ,
        type: 'dashed' // 标记线类型[solid: 直线, dashed: 段线, dotted: 点线]
      }), "label", {
        // 标记线文本
        show: true // 是否显示
        ,
        position: direction === 'xAxis' ? 'insideEndBottom' : 'insideStartTop' // 显示位置
        ,
        formatter: lineType // 内容
        ,
        fontSize: 16 // 字号
        ,
        fontWeight: 'bolder' // 字宽
      });

      // 添加标记线
      this.firstChartsOptions.series[0].markLine.data.push(markLine);
    },
    addMarkAndRefresh: function addMarkAndRefresh(lineType, direction, value, color) {
      this.addMark(lineType, direction, value, this.firstCharts.firstChartsData.yAxis[value], color);

      // 重载图表
      this.firstCharts.obj.setOption(this.firstChartsOptions || {}, true);

      // 重载Graphic组件
      this.initGraphic();
    },
    modifyMarkLine: function modifyMarkLine(lineType, direction, value) {
      // 过滤无效数据
      if (value === null) {
        return;
      }

      // 修改标记线位置
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markLine.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markLine.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markLine.data[i].id === lineType) {
            // 判断标记线类型
            // 移动标记线位置
            this.firstChartsOptions.series[0].markLine.data[i][direction] = value;
            break;
          }
        }
      }
    },
    clearMarkLine: function clearMarkLine(lineType) {
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markLine.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markLine.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markLine.data[i].id === lineType) {
            // 判断标记线类型
            // 移除标记线
            this.firstChartsOptions.series[0].markLine.data.pop(this.firstChartsOptions.series[0].markLine.data[i]);
            break;
          }
        }
      }
    },
    existMarkPoint: function existMarkPoint(pointType) {
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markPoint.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markPoint.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markPoint.data[i].id === pointType) {
            // 判断标记线类型
            return true;
          }
        }
      }
      return false;
    },
    addMarkPoint: function addMarkPoint(pointType, xAxis, yAxis, color) {
      // 过滤无效数据和已存在数据
      if (xAxis === null || yAxis === null || this.existMarkPoint(pointType)) {
        return;
      }

      // 创建标记线对象
      var markPoint = {
        coord: [xAxis, yAxis] // 标记点位置
        ,
        id: pointType // 标记点ID
        ,
        name: pointType // 标记点名称
        ,
        symbol: 'pin' // 标记点图标
        ,
        symbolSize: 20 // 标记点大小
        ,
        itemStyle: {
          // 标记点的样式
          color: color // 标记点颜色
        }
      };

      // 添加标记点
      this.firstChartsOptions.series[0].markPoint.data.push(markPoint);
    },
    modifyMarkPoint: function modifyMarkPoint(pointType, xAxis) {
      // 过滤无效数据
      if (xAxis === null) {
        return;
      }

      // 修改标记点位置
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markPoint.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markPoint.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markPoint.data[i].id === pointType) {
            // 判断标记线类型
            // 移动标记点位置
            this.firstChartsOptions.series[0].markPoint.data[i].coord = [xAxis, this.firstCharts.firstChartsData.yAxis[xAxis]];
            break;
          }
        }
      }
    },
    clearMarkPoint: function clearMarkPoint(pointType) {
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markPoint.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markPoint.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          if (this.firstChartsOptions.series[0].markPoint.data[i].id === pointType) {
            // 判断标记线类型
            // 移除标记线
            this.firstChartsOptions.series[0].markPoint.data.pop(this.firstChartsOptions.series[0].markPoint.data[i]);
            break;
          }
        }
      }
    },
    selectMark: function selectMark(markType) {
      // 遍历所有标示线
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markLine.data.length > 0) {
        for (var i = this.firstChartsOptions.series[0].markLine.data.length - 1; i >= 0; i--) {
          // 遍历标记线数据
          // 变更标记线类型
          this.firstChartsOptions.series[0].markLine.data[i].lineStyle.type = this.firstChartsOptions.series[0].markLine.data[i].id === markType ? 'solid' : 'dashed';
          // 变更标记线颜色
          this.firstChartsOptions.series[0].markLine.data[i].lineStyle.color = this.firstChartsOptions.series[0].markLine.data[i].id === markType ? '#FF0000' : '#00FF00';
        }
      }

      // 遍历所有标示点
      if (this.firstChartsOptions.series.length > 0 && this.firstChartsOptions.series[0].markPoint.data.length > 0) {
        for (var j = this.firstChartsOptions.series[0].markPoint.data.length - 1; j >= 0; j--) {
          // 遍历标记线数据
          // 变更标记线颜色
          this.firstChartsOptions.series[0].markPoint.data[j].itemStyle.color = this.firstChartsOptions.series[0].markPoint.data[j].id === markType ? '#FF0000' : '#00FF00';
        }
      }
    }
  }
};